import React from 'react';

const Section2CommunityInfo = ({ formData, handleChange }) => (
    <div className="fade-in">
        <h4 className="mb-3">2. Community & Religious Information</h4>
        <div className="row">
            <div className="col-md-6 mb-3">
                <label className="form-label">Caste <span className="text-danger">*</span></label>
                <input type="text" name="caste" value={formData.caste} onChange={handleChange} className="form-control" disabled readOnly />
            </div>
            <div className="col-md-6 mb-3">
                <label className="form-label">Sub-caste</label>
                <input type="text" name="subCaste" value={formData.subCaste} onChange={handleChange} className="form-control" placeholder="e.g., Rana, Varia, etc."/>
            </div>
        </div>
        <div className="row">
            <div className="col-md-6 mb-3">
                <label className="form-label">Gotra / Devak</label>
                <input type="text" name="gotra" value={formData.gotra} onChange={handleChange} className="form-control" />
            </div>
             <div className="col-md-6 mb-3">
                <label className="form-label">Kuldaivat (Family Deity)</label>
                <input type="text" name="kuldaivat" value={formData.kuldaivat} onChange={handleChange} className="form-control" />
            </div>
        </div>
    </div>
);

export default Section2CommunityInfo;